import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CurrentUserService } from '@services/auth/current-user.service';
import { BrandingService } from '@services/branding/branding.service';
import { MenuService } from '@services/shared/menu.service';
import { SharedModule } from '@shared/modules/shared.module';
import { BRANDING } from 'app/core/constants/branding.constants';
import { filter, Subscription } from 'rxjs';

@Component({
	selector: 'app-client-navbar',
	standalone: true,
	imports: [SharedModule, RouterLink, RouterLinkActive],
	templateUrl: './client-navbar.component.html',
	styleUrl: './client-navbar.component.scss',
})
export class ClientNavbarComponent implements OnInit, OnDestroy {
	private readonly menuService = inject(MenuService);
	private readonly brandingService = inject(BrandingService);
	private readonly router = inject(Router);
	readonly currentUserService = inject(CurrentUserService);

	isBoostPage = false;
	private routerSub?: Subscription;

	ngOnInit(): void {
		this.isBoostPage = this.router.url.startsWith('/boost');
		this.routerSub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e) => {
			this.isBoostPage = (e as NavigationEnd).urlAfterRedirects.startsWith('/boost');
		});
	}

	ngOnDestroy(): void {
		this.routerSub?.unsubscribe();
	}

	get brandLogo(): string {
		return this.brandingService.current?.logo || BRANDING.logo;
	}

	openProfile(): void {
		this.menuService.setProfileModalState(true);
	}
}
